import { useState, useEffect, useLayoutEffect, useRef, useMemo } from 'react';
import { themeI18n } from '../utils/i18n_helper';
import { formatMoney } from '@shopify/theme-currency';

export const PriceRangeSlider = ({
    priceMax,
    selectedFilters,
    handleFilterChange
  }) => {
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(priceMax);

  const minRangeValueRef = useRef(null);
  const maxRangeValueRef = useRef(null);
  const sliderContainerRef = useRef(null);

  const formattedMinPrice = useMemo(() => formatMoney(parseFloat(minPrice * 100), "{{amount_with_comma_separator}}$").replace(',00', ''), [minPrice]);
  const formattedMaxPrice = useMemo(() => formatMoney(parseFloat(maxPrice * 100), "{{amount_with_comma_separator}}$").replace(',00', ''), [maxPrice]);

  const step = 1;

  useEffect(() => {
    if (selectedFilters) {
      const selectedFilterPriceRange = selectedFilters.find(filter => filter[0] == 'Price_from_to');
      const selectedFilterPriceMin = selectedFilterPriceRange ? selectedFilterPriceRange[1].split("-")[0] : 0;
      const selectedFilterPriceMax = selectedFilterPriceRange ? selectedFilterPriceRange[1].split("-")[1] : priceMax;
      setMinPrice(selectedFilterPriceMin || 0);
      setMaxPrice(selectedFilterPriceMax || priceMax);
    }
  }, [priceMax, selectedFilters]);

  useLayoutEffect(() => {
    const containerWidth = sliderContainerRef.current.offsetWidth;
    const minPosition = (minPrice / priceMax) * containerWidth + 13;
    const maxPosition = (1 - maxPrice / priceMax) * containerWidth + 13;

    if (minRangeValueRef.current) {
      minRangeValueRef.current.style.left = `${minPosition}px`;
    }
    if (maxRangeValueRef.current) {
      maxRangeValueRef.current.style.right = `${maxPosition}px`;
    }
  }, [minPrice, maxPrice, priceMax]);

  const handleLowerChange = (event) => {
    const newValue = parseFloat(event.target.value);
    if (newValue < maxPrice) {
      setMinPrice(newValue);
    }
  };

  const handleUpperChange = (event) => {
    const newValue = parseFloat(event.target.value);
    if (newValue > minPrice) {
      setMaxPrice(newValue);
    }
  };

  const handleSliderChange = () => {
    handleFilterChange("Price_from_to", [minPrice, maxPrice]);
  }

  return (
    <div className="product-listing__price-range-slider" ref={sliderContainerRef}>
      <input
        className="product-listing__range-slider-min"
        aria-label={themeI18n('collection.filters.price_range_min')}
        type="range"
        name="min"
        min={0}
        max={priceMax}
        step={step}
        value={minPrice}
        onChange={handleLowerChange}
        onMouseUp={handleSliderChange}
      />
      <input
        className="product-listing__range-slider-max"
        aria-label={themeI18n('collection.filters.price_range_max')}
        type="range"
        name="max"
        min={0}
        max={priceMax}
        step={step}
        value={maxPrice}
        onChange={handleUpperChange}
        onMouseUp={handleSliderChange}
      />
      <span
        ref={minRangeValueRef}
        className="product-listing__range-value min-range-value text-xsmall"
        >
        {formattedMinPrice}
      </span>
      <span
        ref={maxRangeValueRef}
        className="product-listing__range-value max-range-value text-xsmall"
      >
        {formattedMaxPrice}
      </span>
    </div>
  );
};
